import { createFileRoute } from "@tanstack/react-router"

import { uomLoader } from "@/screens/WarehouseReceiving/loaders"
import { StoredGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/Stored/components"

export const Route = createFileRoute("/app/warehouse-receiving/stored/$goodsReceiptId/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => <StoredGoodsReceiptDetailsLayout />,
})
